<script setup lang="ts">
import { computed } from 'vue'
import type { ScanOutcome } from '@/graphql/generated/graphql'
import { truncationReason } from '@/lib/verdict'
import ToneGlyph from './ToneGlyph.vue'

const props = defineProps<{
  outcome: string | null | undefined
}>()

// The prop is a bare string rather than `ScanOutcome` because the caller may
// be passing through an outcome this client build does not recognize yet.
// `truncationReason` already treats anything outside its known set as a
// generic truncation, so the cast just carries that intent across the prop
// boundary instead of narrowing it away.
const reason = computed(() => truncationReason(props.outcome as ScanOutcome | null | undefined))
</script>

<template>
  <section
    role="alert"
    class="card relative flex overflow-hidden"
    data-tone="unknown"
  >
    <div
      class="tone-stripe w-1 shrink-0"
      aria-hidden="true"
    />
    <div class="flex flex-1 items-start gap-3 p-6">
      <ToneGlyph
        glyph="question"
        :size="20"
      />
      <div class="flex flex-col gap-2">
        <h2 class="text-lg font-semibold">
          This scan did not finish
        </h2>
        <p class="max-w-prose text-ink-muted">
          {{ reason }}
        </p>
      </div>
    </div>
  </section>
</template>
